import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
@Component
export default class ModalHeader extends Vue {
    @Prop({ type: String, default: '' }) header!: string;
    @Prop({ type: String }) description!: string;
    @Prop({ type: Boolean }) explanation!: boolean;
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    mousemove($event: MouseEvent) {
        $event.preventDefault();
        this.$emit('mousedown', $event);
    }
}
